const batteryData = [
  {
    id: "5kwh-lifepo4",
    name: "5 kWh - LiFePO₄ Battery",
    description: [
      {
        title: "Description",
        text: "The Atom Power Wall, featuring lithium-ion technology, offers reliable, long-lasting energy storage with flexible placement options for wall mounting or tabletop use. It supports parallel connections for increased capacity and includes an LCD display and mobile app feature for easy monitoring.",
      },
      {
        title: "Compatible with Inverters",
        text: "Works with most modern solar inverters, making it versatile and easy to integrate into existing solar setups.",
      },
      {
        title: "Temperature Resistance",
        text: "Operates effectively in a range of temperatures, often between -10°C to 50°C, ensuring reliable performance in various climates.",
      },
      {
        title: "Clean Backup Power",
        text: "Provides a green alternative to diesel generators for backup power, eliminating fuel dependency and emissions during power outages.",
      },
      {
        title: "High Discharge (DoD)",
        text: "Typically allows a DoD of around 90%, meaning you can use more of the battery’s capacity without compromising its lifespan.",
      },
      {
        title: "Zero Maintenance",
        text: "Unlike lead-acid batteries, lithium-ion requires no regular maintenance, reducing upkeep costs over its lifetime.",
      },
    ],

    image: "battery.webp",
    brochure: "battery-flyer.pdf",
    manual: "Battery-User-Manual.pdf",
    productOverview: {
      image: "/assets/img/product-3/battery-img.webp",
      imageAlt: "Atom Power 5 kWh LiFePO4 battery",
      eyebrow: "Energy Storage Battery",
      title: "5 kWh - LiFePO₄ Battery",
      price: "Rs.148,000.00",
      compareAtPrice: "Rs.158,000.00",
      discountText: "Save 6%",
      note: "Tax included. Shipping calculated at checkout.",
      actions: [
        {
          label: "ADD TO CART",
          variant: "outline",
        },
        { label: "BUY IT NOW", to: "/contact", variant: "solid" },
      ],
      specs: [
        { label: "Nominal Voltage", value: "51.2 Volts" },
        { label: "Capacity", value: "5.12 kWh" },
        { label: "Life Cycles", value: ">6000" },
        { label: "Warranty", value: "5 years" },
      ],
    },
    gallery: [
      "/assets/img/others/solar-gallery-1.webp",
      "/assets/img/others/solar-gallery-2.webp",
      "/assets/img/others/solar-gallery-3.webp",
    ],
    specifications: {
      "Main Parameters": {
        "Battery Type": "LiFePO4",
        "Capacity": "100 AH",
        "Voltage": "51.2 volts",
        "Operating Voltage Range": "43.2V to 57.6V",
        "Energy Storage": "5.12 kWh",
        "Usable Energy": "4.6 kWh",
        "Display": "LCD Screen",
        "Battery Life": "6000 @ 0.5C (Temp 25°C, EOL 70%)",
      },
      "Charging & Discharging": {
        Recommended: "50 Amps",
        Maximum: "100 Amps",
        "Recommended Battery Usage": "Discharge Up to 90%",
      },
      Environment: {
        "Protection Rating": "IP21",
        "Altitude Limit": "< 2000m",
        "Storage Temperature": "0°C to 35°C",
        "Humidity Tolerance": "5% to 95%",
        "Operating Temperature": "-10°C to 50°C",
      },
      Connectivity: {
        Connectivity: "Wi-Fi (for cloud), CAN and RS485 (for inverter)",
      },
      Mechanical: {
        Weight: "50kg",
        Size: "580 x 520 x 190 mm",
        Installation: "Wall Mounted and Table Top",
      },
      Certifications: {
        Warranty: "5 Years",
        "Safety Standards": "UN38.3 Certified",
      },
    },

    features: [
      {
        title: "Long Cycle Life",
        description:
          "Enjoy long-lasting power with our ATOM Power battery designed for an extended cycle life.",
        iconName: "FaBatteryFull",
      },
      {
        title: "Advanced BMS",
        description:
          "An Advanced BMS keeps your battery running safely and efficiently, maximizing its lifespan and performance.",
        iconName: "FaShieldAlt",
      },
      {
        title: "Fast Charging /Discharging",
        description:
          "ATOM Power delivers fast charging and discharging for energy when you need it.",
        iconName: "FaChargingStation",
      },
      {
        title: "Environmentally Friendly",
        description:
          "ATOM Power offers eco-friendly batteries that reduce your carbon footprint.",
        iconName: "FaLeaf",
      },
      {
        title: "Remote Monitoring",
        description:
          "ATOM Power allows remote monitoring for full control and insights.",
        iconName: "FaWifi",
      },
      {
        title: "Quiet Operation",
        description:
          "ATOM Power ensures quiet operation, providing seamless energy without the noise.",
        iconName: "FaFan",
      },
      {
        title: "WiFi Enabled",
        description:
          "ATOM Power’s WiFi-enabled batteries offer easy connectivity and remote control for convenience.",
        iconName: "FaTools",
      },
      {
        title: "Compatible With Inverters",
        description:
          "Works with solar inverters, making it easy to integrate into existing solar setups.",
        iconName: "FaPlug",
      },
    ],
  },

  {
    id: "2.5kwh-lifepo4",
    name: "2.5 kWh - LiFePO₄ Battery",
    description: [
      {
        title: "Description",
        text: "The Atom Power Wall, featuring advanced lithium-ion (LiFePO₄) technology, offers reliable, long-lasting energy storage with flexible placement options for wall mounting or tabletop use. It supports parallel connections for increased capacity and includes an LCD display and mobile app feature for easy monitoring.",
      },
    ],
    image: "battery.webp", // You can change this if needed
    brochure: "battery-flyer.pdf",
    manual: "Battery-User-Manual.pdf",
    productOverview: {
      image: "/assets/img/product-3/battery-img-2.5.webp",
      imageAlt: "Atom Power 2.5kWh LiFePO4 battery",
      eyebrow: "Energy Storage Battery",
      title: "2.5 kWh - LiFePO₄ Battery",
      price: "Rs.148,000.00",
      compareAtPrice: "Rs.158,000.00",
      discountText: "Save 6%",
      note: "Tax included. Shipping calculated at checkout.",
      actions: [
        {
          label: "ADD TO CART",
          variant: "outline",
        },
        { label: "BUY IT NOW", to: "/contact", variant: "solid" },
      ],
      specs: [
        { label: "Nominal Voltage", value: "25.6 Volts" },
        { label: "Capacity", value: "2.56 kWh" },
        { label: "Life Cycles", value: ">6000" },
        { label: "Warranty", value: "5 years" },
      ],
    },
    gallery: [
      "/assets/img/others/solar-gallery-1.webp",
      "/assets/img/others/solar-gallery-2.webp",
      "/assets/img/others/solar-gallery-3.png",
    ],
    specifications: {
      "Main Parameters": {
        "Battery Type": "LiFePO4",
        Capacity: "100 AH",
        "Nominal Voltage": "25.6V",
        "Operating Voltage Range": "21.6V to 28.8V",
        "Energy Capacity": "2.56 kWh",
        "Usable Capacity": "2.30 kWh",
        "User Interface": "LCD Screen",
        "Battery Cycles": "6000 @ 0.5C (at 25°C, 70% EOL)",
      },
      "Charging & Discharging": {
        "Recommended Current": "50 A",
        "Maximum Current": "100 A",
        "Depth of Discharge": "90%",
      },
      Environment: {
        "Protection Rating": "IP31",
        "Altitude Limit": "< 2000m",
        "Storage Temperature Range": "0°C to 45°C",
        "Humidity Tolerance": "5% to 95%",
        "Operating Temperature Range": "-10°C to 50°C",
      },
      Connectivity: {
        Connectivity: "Wi-Fi (for cloud), CAN and RS485 (for inverter)",
      },
      Mechanical: {
        Weight: "30kg",
        "Mounting Options": "Wall & Table-Top",
        Size: "580 x 320 x 190mm",
      },
    },

    features: [
      {
        title: "Capacity & Voltage",
        description:
          "This battery provides a substantial 2.56kWh capacity and operates at 25.6V.",
        iconName: "FaBatteryFull",
      },
      {
        title: "Compatible with Hybrid Inverters",
        description:
          "Designed to work seamlessly with most modern solar inverters , including Atom Power branded hybrid inverters which support Li-ion battery BMS communication. This ensures versatile and easy integration into existing or new solar setups.",
        iconName: "FaPlug",
      },
      {
        title: "Temperature Resistance",
        description:
          "Operates effectively in a wide range of temperatures, from -10°C to 50°C, ensuring reliable performance in various climates.",
        iconName: "FaFan",
      },
      {
        title: "Clean Backup Power",
        description:
          "Provides a green alternative to diesel generators for backup power, eliminating fuel dependency and emissions during power outages.",
        iconName: "FaLeaf",
      },
      {
        title: "High Depth of Discharge (DoD)",
        description:
          "Typically allows a DoD of around 90%, meaning you can use more of the battery’s capacity without compromising its lifespan.",
        iconName: "FaChargingStation",
      },
      {
        title: "Zero Maintenance",
        description:
          "Unlike lead-acid batteries, lithium-ion batteries require no regular maintenance, reducing upkeep costs over their lifetime. ",
        iconName: "FaTools",
      },
      {
        title: "Reliable Performance",
        description:
          "Pairs well with Atom Power branded inverters that output high-quality pure sine wave AC power, ensuring stable and clean energy for your appliances.",
        iconName: "FaLightbulb",
      },
    ],
  },
];

export default batteryData;
